<template>
  <span>{{ displayNumber || 0 }}</span>
</template>

<script>
import inViewport from "vue-in-viewport-mixin"
export default {
  name: "AnimatedNumber",
  mixins: [inViewport],
  props: {
    number: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 20
    },
    change: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      displayNumber: 0,
      interval: false
    }
  },
  activated() {
    this.displayNumber = 0
  },
  watch: {
    number: {
      handler() {
        clearInterval(this.interval)
        if (this.number == this.displayNumber) {
          return
        }
        this.interval = window.setInterval(() => {
          if (this.displayNumber != this.number) {
            var change = (this.number - this.displayNumber) / 10
            change = change >= 0 ? Math.ceil(change) : Math.floor(change)
            this.displayNumber = this.displayNumber + change
          }
        }, this.duration)
      },
      immediate: true
    },
    "inViewport.below"() {
      this.displayNumber = 0
    }
  }
}
</script>
